/**
 * formatMoney — pure helper to render decimal-string money for display.
 *
 * Inputs are STRINGS (per ADR-001 §5 + upmp/no-number-money rule). We do not
 * do arithmetic — only thousands-grouping + currency-symbol prefix.
 *
 * Default currency is NGN with the ₦ symbol (NIPOST domestic). Other ISO
 * codes fall through to a `<CODE> ` prefix.
 */
const CURRENCY_SYMBOLS: Record<string, string> = {
  NGN: '₦', // ₦
  USD: '$',
  EUR: '€',
  GBP: '£',
};

export function formatMoney(amount: string, currency = 'NGN'): string {
  if (typeof amount !== 'string' || amount.length === 0) {
    return `${prefix(currency)}0.00`;
  }

  if (!/^\d+(\.\d+)?$/.test(amount)) {
    // Defensive — surface raw input rather than silently corrupting.
    return `${prefix(currency)}${amount}`;
  }

  const [whole, fraction = ''] = amount.split('.');
  const grouped = (whole ?? '0').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // Normalise to 2dp for display. Drop trailing zeros beyond 2.
  const padded = (fraction + '00').slice(0, 2);
  return `${prefix(currency)}${grouped}.${padded}`;
}

function prefix(currency: string): string {
  return CURRENCY_SYMBOLS[currency] ?? `${currency} `;
}
